import { createLazyStringIfUmd } from '@/utils/lazyString';

export const EMPLOYER_BASE_URL = createLazyStringIfUmd(
  () => import.meta.env.VITE_EMPLOYER_BASE_URL || '',
);
export const EMPLOYER_BASE_PATH = createLazyStringIfUmd(
  () => import.meta.env.VITE_EMPLOYER_BASE_PATH || '',
);
export const SECURITY_SERVICE_BASE_URL = createLazyStringIfUmd(
  () =>
    import.meta.env.VITE_SECURITY_SERVICE_BASE_URL ?? 'http://localhost:8107',
);
export const TODO_SERVICE_BASE_URL = createLazyStringIfUmd(
  () => import.meta.env.VITE_TODO_SERVICE_BASE_URL ?? 'http://localhost:8109',
);
export const EMPLOYMENT_SERVICE_BASE_URL = createLazyStringIfUmd(
  () =>
    import.meta.env.VITE_EMPLOYMENT_SERVICE_BASE_URL ?? 'http://localhost:8118',
);
export const AGENTIC_AI_SETTINGS_PATH = createLazyStringIfUmd(
  () => `${EMPLOYER_BASE_PATH}/settings/fountain-copilot`,
);
export const AGENTIC_AI_SETTINGS_URL = createLazyStringIfUmd(
  () => `${EMPLOYER_BASE_URL}${AGENTIC_AI_SETTINGS_PATH}`,
);
export const AGENTIC_AI_CUE_URL = createLazyStringIfUmd(
  () => `${EMPLOYER_BASE_URL}${EMPLOYER_BASE_PATH}/cue`,
);
export const CUE_SCHEDULED_PATH = createLazyStringIfUmd(
  () => `${EMPLOYER_BASE_PATH}/cue/scheduled`,
);

/** Regex to match artifact print page route: /artifacts/:id/print */
export const ARTIFACT_PRINT_PAGE_PATTERN = /\/artifacts\/[^/]+\/print$/;

export const MAX_CUSTOM_ATTRIBUTE_LABEL_SIZE = 200;
export const MAX_COMPANY_NAME_SIZE = 100;

export enum SidebarMode {
  Open,
  Closed,
  Hidden,
}

export const LoginMethod = {
  Password: 'password',
  Uuid: 'uuid',
  Token: 'token',
} as const;

export type LoginMethodType = (typeof LoginMethod)[keyof typeof LoginMethod];

export const AuthStatus = {
  Authenticated: 'authenticated',
  Unauthenticated: 'unauthenticated',
  NeedsTfaSetup: 'needsTfaSetup',
  AwaitingOtpCode: 'awaitingOtpCode',
  PasswordExpired: 'passwordExpired',
  PasswordLeaked: 'passwordLeaked',
} as const;

export type AuthStatusType = (typeof AuthStatus)[keyof typeof AuthStatus];

export const AuthError = {
  InvalidCredentials: 'invalid-credentials',
  InvalidOtp: 'invalid-otp',
  Locked: 'locked',
  OtpLocked: 'otp-locked',
  LockedFromInactivity: 'locked-from-inactivity',
  Generic: 'generic',
} as const;

export type AuthErrorType = (typeof AuthError)[keyof typeof AuthError];

export const SYSTEM_USER_EMAIL = 'system@fountain.com';

/** Matches service-account API users, e.g. service-account+<id>@fountain.com */
export const SERVICE_ACCOUNT_EMAIL_REGEX =
  /^service-account\+.*@fountain\.com$/i;

/**
 * Shared DOM id for the flex region above the Customer.io bottom banner.
 * Cue measures this element for sidebar height. CSS remaps h-screen/h-dvh
 * inside this node to 100% (see app-container.css).
 */
export const APP_CONTAINER_ID = 'app-container';

/** Outer stack for bottom page banners — measure this for total banner height. */
export const BOTTOM_BANNER_CONTAINER_ID = 'employer-bottom-banner';

/**
 * Customer.io bottom inline Position ID — must match campaign config exactly.
 * Mounted inside BottomBanner.
 */
export const CUSTOMERIO_BOTTOM_BANNER_POSITION_ID = 'customerio-bottom-banner';
